module.exports = __webpack_public_path__ + "files/c826fe1937a2dd42a9a36d37f317411e.svg";